<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>

<script>
export default {
  computed: {
    // Método que retorna o layout que a página deve possuir
    // Verificando se possui na configuração de rotas um objeto meta com a propriedade layout
    // O padrão é LayoutBasico.
    layout() {
      return this.$route.meta.layout || 'LayoutBasico'
    },
  },
}
</script>

<style lang="scss">
@import '@/scss/colors.scss';

html,
body {
  height: 100vh;
  width: 100%;
}

#app {
  display: flex;
  min-height: 100vh;
  width: 100%;
  background-color: $cor-fundo;
  font-size: 16px;
}

</style>
